import axios from 'axios';
import md5 from 'js-md5';

import { compareVersions } from './format';

const service = axios.create({
  baseURL: window.BASE_API, // api的base_url
  timeout: 20000 // request timeout
});

function getUrlQuery(paramName) {
  var url = document.location.toString();
  var arrObj = url.split('?');
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&');
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=');

      if (arr != null && arr[0] === paramName) {
        return arr[1];
      }
    }
    return '';
  } else {
    return '';
  }
}

function apiInfo() {
  let TimeStamp = Date.now();
  let AccessKey = window.config.AccessKey;
  let SecretKey = window.config.SecretKey;
  let Nonce = 'lhjy' + TimeStamp;
  // Sign : 签名
  let strA = 'AccessKey=' + AccessKey + '&Nonce=' + Nonce + '&TimeStamp=' + TimeStamp;
  let strB = strA + '&SecretKey=' + SecretKey;
  // MD5 转 大写
  let sign = md5(strB).toUpperCase();
  let token = getUrlQuery('token');
  // 如果Token 为空跳转登录
  if (token == '' || token == 'NoToken') {
    token = '';
    // window.location.href = 'dzh_browser_url&goto=0&screen=442';
  }

  // 获取版本号
  let versions = getUrlQuery('version');
  let Mobile = 1;
  if ( compareVersions(versions,9.71)) {
    Mobile = 2;
  } else {
    Mobile = 1;
  }

  let obj = {
    Nonce: Nonce,
    TimeStamp: TimeStamp,
    sign: sign,
    token: decodeURIComponent(token),
    Mobile: Mobile
  };
  return obj;
}
// request interceptor
service.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.params = apiInfo();
    } else {
      let obj = apiInfo();
      config.params.token = obj.token; //如果要求携带在参数中
      config.params.Nonce = obj.Nonce; //如果要求携带在参数中
      config.params.TimeStamp = obj.TimeStamp; //如果要求携带在参数中
      config.params.sign = obj.sign; //如果要求携带在参数中
      config.params.Mobile = obj.Mobile;
      if (!config.params.Mobile) {
        config.params.Mobile = 1; //如果要求携带在参数中
      }
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.log('err' + error); // for debug
    return Promise.reject(error);
  }
);

export default service;
